export const enum Continents {
  Europe = 'Europe',
  Africa = 'Africa',
  'Asia & Oceania' = 'Asia & Oceania',
  'Middle East' = 'Middle East',
  America = 'America',
  'Other destinations' = 'Other destinations'
}
